import { MerchantDto } from './merchant.dto';
import { BaseDto } from './base.dto';
import { MerchantConfigurationDto } from './merchantConfiguration.dto';

export class MerchantConfigurationSettingsDto extends BaseDto {
  merchant?: MerchantDto;
  group?: string;
  flytApiKey?: MerchantConfigurationDto;
  flytLocationRefId?: MerchantConfigurationDto;
  flytVendorName?: MerchantConfigurationDto;
  flytCollectionMenu?: MerchantConfigurationDto;
  flytDeliveryMenu?: MerchantConfigurationDto;
  flytUpcoApiKey?: MerchantConfigurationDto;
  enableJustEatIntegration?: boolean;
  deliverooBrandName?: MerchantConfigurationDto;
  deliverooMenuName?: MerchantConfigurationDto;
  deliverooAPIKey?: MerchantConfigurationDto;
  deliverooAPIToken?: MerchantConfigurationDto;
  deliverooLocationRefId?: MerchantConfigurationDto;
  enableDeliverooIntegration?: boolean;
  uberEatsClientId?: MerchantConfigurationDto;
  uberEatsClientSecret?: MerchantConfigurationDto;
  uberEatsStoreId?: MerchantConfigurationDto;
  uberEatsMenuName?: MerchantConfigurationDto;
  enableUberEatsIntegration?: boolean;
  posQuickPayPaymentMethod?: MerchantConfigurationDto;
  posProductSearch?: MerchantConfigurationDto;
  posSendAndPay?: MerchantConfigurationDto;
}
